import React, { FC } from 'react';
import {
  Body,
  Card,
  Heading,
  SelectButton,
  SelectDynamicButton,
} from '@trevor/ui-components';
import styled from 'styled-components';
import { DATABASE_SETUP_TYPE } from '@/containers/DatasourcesPage/components/ConnectDatasourceSection/utils';

const SelectButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  > button {
    width: 231px;
  }
`;

type HerokuQuickSetupStepProps = {
  selectedValue: Maybe<string>;
  onSelect: F<string>;
};
export const HerokuQuickSetupStep: FC<HerokuQuickSetupStepProps> = ({
  selectedValue,
  onSelect,
}) => {
  const isHerokuDatabaseUrlSelected = Boolean(
    selectedValue && selectedValue !== DATABASE_SETUP_TYPE.heroku,
  );

  const handleHerokuSelection = () => {
    window.location.href = '/heroku';
  };

  return (
    <Card width="100%" alignItems="center" padding={32} gap={32}>
      <Heading variant={4}>Step 2: Heroku quick set up</Heading>
      <SelectButtonContainer>
        <SelectButton
          value={DATABASE_SETUP_TYPE.heroku}
          iconName="heroku"
          isSelected={selectedValue === DATABASE_SETUP_TYPE.heroku}
          onClick={handleHerokuSelection}
        >
          Heroku app
        </SelectButton>
        <Body variant={1}>or</Body>
        <SelectDynamicButton
          iconName="web"
          placeholder="Url"
          label="Heroku Database URL"
          value={selectedValue ?? ''}
          isSelected={isHerokuDatabaseUrlSelected}
          onSelect={(value) => onSelect(value as string)}
        />
      </SelectButtonContainer>
    </Card>
  );
};
